<main class="inset">
  <h1>Data sources</h1>
  <ul>
    <li>
      <a href="https://www.openstreetmap.org/copyright/en">© OpenStreetMap contributors</a>
    </li>
    <li>Binfinder contributors</li>
  </ul>
</main>
